import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';
import * as api from '../services/api';

interface UploadState {
  loading: boolean;
  jobId: string | null;
  error: string | null;
  jobStatus: string | null;
  jobProgress: number;
  jobResultUrl: string | null;
  jobError: string | null;
}

const initialState: UploadState = {
  loading: false,
  jobId: null,
  error: null,
  jobStatus: null,
  jobProgress: 0,
  jobResultUrl: null,
  jobError: null,
};

export const submitHDF5Upload = createAsyncThunk(
  'upload/submit',
  async (file: File, { rejectWithValue }) => {
    try {
      const presignRes = await api.getPresignedURL(file.name);

      // TODO: better loggging
      console.log('📡 Presign Response:', presignRes);

      const { presigned_url, s3_key, file_uuid } = presignRes;

      console.log("📤 Uploading to S3:", presigned_url);

      await fetch(presigned_url, {
        method: 'PUT',
        // Note: adding header would have conflict with s3
        // headers: {
        // 'Content-Type': file.type,
        // },
        body: file,
      });

      const submitJobRes = await api.submitJob({ s3_key, uuid: file_uuid})
      const job_id = submitJobRes.job_id;

      console.log('🚀 Job submitted:', job_id);

      return { job_id };
    } catch (err: any) {
      return rejectWithValue(err.message || 'Upload failed');
    }
  }
);

export const pollJobStatus = createAsyncThunk(
  'upload/pollStatus',
  async (job_id: string, { rejectWithValue }) => {
    try {
      const res = await api.getJobStatus(job_id);
      return res; // will contain {status, progress, result_url, error_message}
    } catch (err:any) {
      return rejectWithValue(err.message || 'Plling failed');
    }
  }
);

const uploadSlice = createSlice({
  name: 'upload',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(submitHDF5Upload.pending, (state) => {
      state.loading = true;
      state.error = null;
      state.jobStatus = null;
      state.jobProgress = 0;
      state.jobResultUrl = null;
      state.jobError = null;
    });
    builder.addCase(submitHDF5Upload.fulfilled, (state, { payload }) => {
      console.log('[Reducer] setting jobId:', payload.job_id);
      state.loading = false;
      state.jobId = payload.job_id;
    });
    builder.addCase(submitHDF5Upload.rejected, (state, { payload }) => {
      state.loading = false;
      state.error = payload as string;
    });
    builder.addCase(pollJobStatus.fulfilled, (state, { payload }) => {
      state.jobStatus = payload.status;
      state.jobProgress = payload.progress;
      state.jobResultUrl = payload.result_url;
      state.jobError = payload.error_message;
    });
    builder.addCase(pollJobStatus.rejected, (state, { payload }) => {
      state.jobError = payload as string;
    })
  },
});

export default uploadSlice.reducer;

export const selectUploadState = (state: RootState) => state.upload;
